import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedDecoration = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 988.6 1080",
	preserveAspectRatio: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: url(#Degradado_sin_nombre_5);\n      }\n\n      .st2 {\n        clip-path: url(#clippath);\n      }\n    " }),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clippath",
			children: /* @__PURE__ */ _jsx("rect", {
				className: "st0",
				x: 0,
				y: 0,
				width: 988.6,
				height: 1080
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Degradado_sin_nombre_5",
			"data-name": "Degradado sin nombre 5",
			x1: 2389.46,
			y1: 852.67,
			x2: 3905.79,
			y2: 852.67,
			gradientTransform: "translate(3365.98) rotate(-180) scale(1 -1)",
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#e40406"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#b10103"
			})]
		})
	] }), /* @__PURE__ */ _jsx("g", {
		className: "st2",
		children: /* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M-539.81,852.67c0,418.72,339.44,758.16,758.16,758.16,418.72,0,758.16-339.44,758.16-758.16,0-418.72-339.44-758.16-758.16-758.16-418.72,0-758.16,339.44-758.16,758.16ZM-174.47,852.67c0-216.95,175.88-392.83,392.83-392.83,216.95,0,392.83,175.88,392.83,392.83,0,216.95-175.88,392.83-392.83,392.83-216.95,0-392.83-175.88-392.83-392.83Z"
		})
	})]
});
export default SvgRedDecoration;
